/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CryptoVsStocksDto
 */
export interface CryptoVsStocksDto {
    /**
     * Number of users holding cryptocurrency
     * @type {number}
     * @memberof CryptoVsStocksDto
     */
    cryptoUsers: number;
    /**
     * Number of users holding stocks/ETF
     * @type {number}
     * @memberof CryptoVsStocksDto
     */
    stocksUsers: number;
    /**
     * Number of users holding both crypto and stocks
     * @type {number}
     * @memberof CryptoVsStocksDto
     */
    bothUsers: number;
    /**
     * Percentage of users holding cryptocurrency
     * @type {number}
     * @memberof CryptoVsStocksDto
     */
    cryptoPercentage: number;
}

export function CryptoVsStocksDtoFromJSON(json: any): CryptoVsStocksDto {
    return CryptoVsStocksDtoFromJSONTyped(json, false);
}

export function CryptoVsStocksDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CryptoVsStocksDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cryptoUsers': json['cryptoUsers'],
        'stocksUsers': json['stocksUsers'],
        'bothUsers': json['bothUsers'],
        'cryptoPercentage': json['cryptoPercentage'],
    };
}

export function CryptoVsStocksDtoToJSON(value?: CryptoVsStocksDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cryptoUsers': value.cryptoUsers,
        'stocksUsers': value.stocksUsers,
        'bothUsers': value.bothUsers,
        'cryptoPercentage': value.cryptoPercentage,
    };
}

